<div appTheme *ngIf="locationManager.weatherToday" class="no-select" (click)="$event.preventDefault(); $event.stopPropagation()">
    <div class="weather-item-container">
        <div class="weather-date">
            <div class="weather-day">TODAY</div>
            <div class="weather-month">
                {{locationManager.weatherToday.WeatherDate | date: 'MMMM' | uppercase | slice: 0:3}} {{locationManager.weatherToday.WeatherDate | date: 'd'}}
            </div>
        </div>

        <div class="weather-icon-and-temperature">
            <div class="weather-icon">
                <i [ngClass]="locationManager.weatherToday.WeatherIcon"></i>
            </div>
            <div class="weather-temperature">
                {{locationManager.weatherToday.AirTemperatureMax}}&#176; / {{locationManager.weatherToday.AirTemperatureMin}}&#176;
            </div>
        </div>

        <div class="weather-precipitation-info">
            <i class="fa fa-tint"></i>
            <div>{{locationManager.weatherToday.PrecipitationProbability}}%</div>
        </div>

        <div class="weather-caret-icon" (click)="forecastIsDisplayed = !forecastIsDisplayed">
            <i class="fa fa-lg fa-caret-down" [ngClass]="{'fa-caret-down': !forecastIsDisplayed, 'fa-caret-up': forecastIsDisplayed}"></i>
        </div>
    </div>

    <div *ngIf="forecastIsDisplayed" class="weather-forecast-items-container">
        <div *ngFor="let weatherForecastDay of locationManager.weatherForecast; index as i">
            <div class="weather-item-container">
                <div class="weather-date">
                    <div class="weather-day">{{weatherForecastDay.WeatherDate | date: 'EEEE' | uppercase | slice: 0:3}}</div>
                    <div class="weather-month">
                        {{weatherForecastDay.WeatherDate | date: 'MMMM' | uppercase | slice: 0:3}} {{weatherForecastDay.WeatherDate | date: 'd'}}
                    </div>
                </div>

                <div class="weather-icon-and-temperature">
                    <div class="weather-icon">
                        <i [ngClass]="weatherForecastDay.WeatherIcon"></i>
                    </div>
                    <div class="weather-temperature">{{weatherForecastDay.AirTemperatureMax}}&#176; / {{weatherForecastDay.AirTemperatureMin}}&#176;</div>
                </div>

                <div class="weather-precipitation-info">
                    <i class="fa fa-tint"></i>
                    <div>{{weatherForecastDay.PrecipitationProbability}}%</div>
                </div>
            </div>

            <hr *ngIf="i !== locationManager.weatherForecast.length" class="gradient-style no-margin-top no-margin-bottom">
        </div>
    </div>
</div>
